import { render, staticRenderFns } from "./DetalleProducto.vue?vue&type=template&id=46a76df0&scoped=true"
import script from "./DetalleProducto.vue?vue&type=script&lang=js"
export * from "./DetalleProducto.vue?vue&type=script&lang=js"
import style0 from "./DetalleProducto.vue?vue&type=style&index=0&id=46a76df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a76df0",
  null
  
)

export default component.exports